import React from "react";
import GebrauchstauglichkeitsaktePage from "../components/AktePage/GebrauchstauglichkeitsaktePage";

export default function Gebrauchstauglichkeitsakte(){
    return(
        <GebrauchstauglichkeitsaktePage/>
    );
}